module.exports = __webpack_public_path__ + "img/8.9.TU.88d5a798.png";